import React from 'react';
import ReactDOM from 'react-dom';
import Amplify, { API } from 'aws-amplify';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import Gleap from 'gleap';
import history from './utils/history';
import config from './aws-exports';
import './index.css';
import App from './containers/app/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

Gleap.initialize('VVzsP1nAYwf1zS5rFKVg7QVSmrSiOYBn');

Amplify.configure(config);
API.configure(config);

Sentry.init({
  dsn: 'https://e48a39e1ccc44f58a5cb6fa3a655a58c@o120608.ingest.sentry.io/5917202',
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  // eslint-disable-next-line no-undef
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
